<template>
  <section class="countries-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="countries-illustration">
            <img :src="require('@/assets/img/Illustration (1).png')" alt="6 pays UEMOA" class="illustration-img">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="countries-content">
            <h2 class="countries-title">6 pays, une seule plateforme</h2>
            <p class="countries-description">
              Nolido Cash est présente dans six (06) pays de la zone UEMOA. 
              Nous avons également des projets d'expansion en Guinée-Bissau, Niger, 
              Nigeria, Cameroun, Gabon et RDC
            </p>
            <CustomButton
              label="En savoir plus sur nous" 
              @click="handleLearnMore"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: "CountriesSection",
  components: {
    CustomButton
  },
  methods: {
    handleLearnMore() {
      // Navigation vers la page "À propos"
      this.$router.push('/about-nolido');
    }
  }
};
</script>

<style scoped>
.countries-section {
  background: white;
  padding: 80px 0;
  position: relative;
}

.countries-illustration {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.illustration-img {
  width: 100%;
  max-width: 450px;
  height: auto;
  object-fit: contain;
}

.countries-content {
  padding: 2rem;
  padding-left: 3rem;
}

.countries-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  letter-spacing: -0.03em;
}

.countries-description {
  font-size: 1.05rem;
  color: #4A4A4A;
  line-height: 1.65;
  margin-bottom: 2rem;
  font-weight: 400;
}

@media (max-width: 992px) {
  .countries-section {
    padding: 60px 0;
  }

  .countries-title {
    font-size: 2rem;
  }

  .countries-content {
    padding: 2rem;
    padding-left: 2rem;
  }
}

@media (max-width: 768px) {
  .countries-content {
    padding: 1rem;
    text-align: center;
  }

  .countries-title {
    font-size: 1.75rem;
  }

  .countries-description {
    font-size: 0.95rem;
  }

  .illustration-img {
    max-width: 350px;
  }
}
</style>
